import React from 'react';
import { motion } from 'framer-motion';
import { Activity, Brain, Heart, TrendingUp, Moon } from 'lucide-react';

export function JournalMetrics() {
  const metrics = [
    {
      title: 'Behaviors Tracked',
      value: '12',
      change: '+2',
      icon: <Activity className="w-4 h-4" />,
      color: 'text-success'
    },
    {
      title: 'Completion Rate',
      value: '85%',
      change: '+5%',
      icon: <Brain className="w-4 h-4" />,
      color: 'text-success'
    },
    {
      title: 'Streak',
      value: '7',
      change: '+1',
      icon: <Heart className="w-4 h-4" />,
      color: 'text-success'
    },
    {
      title: 'Consistency',
      value: '92%',
      change: '+3%',
      icon: <Moon className="w-4 h-4" />,
      color: 'text-success'
    }
  ];

  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
      {metrics.map((metric, index) => (
        <motion.div
          key={metric.title}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: index * 0.1 }}
          className="theme-card p-4 relative overflow-hidden"
        >
          <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-50" />
          
          <div className="relative space-y-2">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                {metric.icon}
                <span className="text-sm font-medium">{metric.title}</span>
              </div>
              <div className={`flex items-center gap-1 text-xs ${metric.color}`}>
                <TrendingUp className="w-3 h-3" />
                <span>{metric.change}</span>
              </div>
            </div>

            <div className="text-2xl font-bold">{metric.value}</div>
          </div>
        </motion.div>
      ))}
    </div>
  );
}